import {createApp} from 'vue'
import App from './App.vue'
// importing AOS css style globally
import 'aos/dist/aos.css'

createApp(App).mount('#app')
